import { combineReducers } from 'redux'

import draftEditor from './draftEditor'
import appReducer from './appReducer'
import storyData from './storyData'
import settings from './settingsReducer'
import websked from './websked'
import tansa from './tansaReducer'
import route from './routeReducer'
import picklistsReducer from './picklistsReducer'
import tabsReducer from './globalReducers/tabsReducer'
import { reducer as editorFieldsReducer } from './editor-fields'
import { reducer as websitesReducer } from './websites'

// A list of reducers getting full application state
const fullScopeReducers = [tabsReducer]

// combineReducers https://redux.js.org/docs/recipes/reducers/UsingCombineReducers.html
// Instead of managing one big state and make copy of it for each action handler,
// combineReducers gives ability to slice app state to logicaly gouped chunks of state.
export default () => {
  const scopedReducers = combineReducers({
    appState: appReducer,
    draftEditor,
    storyData,
    settings,
    websked,
    tansa,
    route,
    picklists: picklistsReducer,
    editorFields: editorFieldsReducer,
    websites: websitesReducer,
  })

  return (state, action) => {
    const updatedState = scopedReducers(state, action)
    return fullScopeReducers.reduce((theState, reducer) => {
      return reducer(theState, action)
    }, updatedState)
  }
}
